import { render, staticRenderFns } from "./TabLabelRound.vue?vue&type=template&id=63b47f0e&scoped=true"
import script from "./TabLabelRound.vue?vue&type=script&lang=js"
export * from "./TabLabelRound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b47f0e",
  null
  
)

export default component.exports